import React from "react";
import styles from "./styles.module.scss";
import Timeline from "../../Timeline";
// import ClockIcon from "../../../shared/iconComponents/ClockIcon";
// import CheckIcon from "../../../shared/iconComponents/CheckIcon";

const TrackingProgress = ({ progress = 65, data, isDelivered }) => {

  return (
    <div className={styles.trackingProgress}>
      {/* <div className={styles.progressBar}>
        <div
          className={styles.progress}
          style={{ width: `${progress}%` }}
        ></div>
        <span
          className={styles.clockIconWrapper}
          style={{ left: `${progress}%` }}
        >
          {isDelivered ? <CheckIcon/> : <ClockIcon />}
        </span>
      </div> */}

      {/* <div className={styles.fullDestination}>
        <p>{data?.originCountry || "-"}</p>
        <p>{data?.destinationCountry || "-"}</p>
        <p>Получатель</p>
      </div> */}
      <div className={styles.progressInfo}>
        {data.checkpoints.length !== 0 && (
          <Timeline timelineContent={data.checkpoints} />
        )}
      </div>
    </div>
  );
};

export default TrackingProgress;
